import { VpIcon, VpIconButton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { FavoriteViewEmojiPicker } from '@/components/FavoriteViews/FavoriteViewEmoji'

interface FavoriteViewFolderFieldsProps {
  name: string
  selectedEmoji: string | null
  onNameChange: (name: string) => void
  onEmojiSelect: (unified: string) => void
  onCancel?: () => void
}

export function FavoriteViewFolderFields({
  name,
  selectedEmoji,
  onNameChange,
  onEmojiSelect,
  onCancel,
}: Readonly<FavoriteViewFolderFieldsProps>) {
  const { t } = useTranslation()

  return (
    <div className={`favorite-view-panel__folder-fields${onCancel ? ' favorite-view-panel__folder-fields--with-cancel' : ''}`}>
      <label className="favorite-view-panel__field">
        <span>{t('favorite-views.panel.folder-emoji')}</span>
        <FavoriteViewEmojiPicker
          selectedEmoji={selectedEmoji}
          onSelect={onEmojiSelect}
        />
      </label>
      <label className="favorite-view-panel__field">
        <span>{t('favorite-views.panel.folder-name')}</span>
        <input
          id="favorite-folder-name"
          autoComplete="off"
          maxLength={80}
          value={name}
          onChange={event => onNameChange(event.target.value)}
          data-testid="favorite-folder-name"
        />
      </label>
      {onCancel && (
        <VpIconButton
          className="favorite-view-panel__folder-cancel"
          type="button"
          variant="tertiary"
          aria-label={t('favorite-views.panel.cancel-folder-creation')}
          onClick={onCancel}
          data-testid="favorite-view-cancel-folder"
        >
          <VpIcon name="delete-bin" />
        </VpIconButton>
      )}
    </div>
  )
}
